import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header';
import Footer from './components/Footer';
import PageTemplate from './pages/PageTemplate';

function App() {
  return (
    <div className="flex flex-col min-h-screen bg-white text-slate-700 antialiased font-sans">
      <ScrollToTop />
      {/* Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-grow">
        <Routes>
          {/* Home Route */}
          <Route path="/" element={<PageTemplate />} />

          {/* Dynamic Page Routes */}
          <Route path="/:slug" element={<PageTemplate />} />
        </Routes>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
